import { Notyf } from 'notyf';

const notyf = new Notyf({position: {x: 'center', y: 'top'}});

export default notyf;